import to from 'await-catch'
import React, { useState } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { Calendar } from '../../../../assets/icons'
import AddToCalendarQuickAccessModal from '../../../../components/AddToCalendarQuickAccessModal'
import { Button } from '../../../../components/ui/button'
import { BackPageHeader } from '../../../../components/ui/header'
import { confirmAppointment } from '../../../../api'
import useIsMobile from '../../../../hooks/useIsMobile'
import { MOBILE_BOTTOM_NAV_HEIGHT } from '../../../../components/ui/layout/mobileLayout/styled'
import theme from '../../../../styled/theme'
import { buildAppointmentCalendarEvent } from '../../../../utils/appointmentCalendarEvent'
import { buildConfirmAppointmentParams } from './buildConfirmAppointmentParams'

const ConfirmSingleAppointment = ({
	onBack,
	onConfirmed,
	turn,
	patient,
	showLoader,
	hideLoader,
	addFlashMessage,
	auth
}) => {
	const history = useHistory()
	const isMobile = useIsMobile()
	const [isConfirmed, setIsConfirmed] = useState(false)
	const [showCalendarModal, setShowCalendarModal] = useState(false)

	const calendarEvent = isConfirmed && turn ? buildAppointmentCalendarEvent(turn) : null

	const confirm = async () => {
		if (!turn) {
			addFlashMessage('No hay turno seleccionado para confirmar')
			return
		}

		try {
			showLoader()
			const params = buildConfirmAppointmentParams({ turn, patient, auth })
			const [err] = await to(confirmAppointment(params))

			if (err) throw new Error('Error del servidor')

			setIsConfirmed(true)
			if (onConfirmed) onConfirmed()
		} catch (error) {
			addFlashMessage('Ocurrió un error al confirmar el turno')
		} finally {
			hideLoader()
		}
	}

	return (
		<>
			<AddToCalendarQuickAccessModal
				isOpen={showCalendarModal}
				onClose={() => setShowCalendarModal(false)}
				isFullHeight={isMobile}
				event={calendarEvent}
			/>
			<Container>
				<Content>
					<BackPageHeader
						onBack={onBack}
						showBack={!isConfirmed && !isMobile}
						title={isConfirmed ? 'Turno confirmado' : 'Agendar turno'}
						marginBottom="24px"
					/>

					<Section>
						<SectionTitle>Detalle</SectionTitle>
						<DetailsGrid>
							<DetailItem>
								<DetailLabel>Profesional</DetailLabel>
								<DetailValue>{turn?.nombreProfesional || '-'}</DetailValue>
							</DetailItem>
							<DetailItem>
								<DetailLabel>Especialidad</DetailLabel>
								<DetailValue>{turn?.nombreEspecialidad || '-'}</DetailValue>
							</DetailItem>
							<DetailItem>
								<DetailLabel>Fecha</DetailLabel>
								<DetailValue>{turn?.fechaTurno || '-'}</DetailValue>
							</DetailItem>
							<DetailItem>
								<DetailLabel>Dirección</DetailLabel>
								<DetailValue>{turn?.direccion || '-'}</DetailValue>
							</DetailItem>
						</DetailsGrid>
					</Section>
				</Content>

				<ButtonWrapper>
					{!isConfirmed ? (
						<Button
							type="primary"
							onClick={confirm}
							label="Confirmar"
							size={isMobile ? 'mobile' : 'xlarge'}
						/>
					) : (
						<>
							<Button
								$showBorder={false}
								$mt={'0px'}
								label={'Volver al inicio'}
								$variant="primary"
								size={isMobile ? 'mobile' : 'xlarge'}
								onClick={() => history.push('/inicio')}
							/>
							<Button
								iconLeft={<Calendar color={theme.colors.brand.blueOmint} />}
								$showBorder={false}
								$mt={'0px'}
								label={'Agregar a calendario'}
								$variant="secondary"
								size={isMobile ? 'mobile' : 'xlarge'}
								$underline={true}
								onClick={() => setShowCalendarModal(true)}
							/>
						</>
					)}
				</ButtonWrapper>
			</Container>
		</>
	)
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 80vh;
	width: 80vw;
	padding: 20px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 100%;
		padding: 16px 16px 96px 16px;
	}
`

const Content = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`

const Section = styled.div`
	margin-bottom: 24px;
`

const SectionTitle = styled.h2`
	font-size: 16px;
	font-weight: 600;
	color: ${props => props.theme.colors.text.titleText};
	margin: 0 0 16px 0;
`

const DetailsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 28px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		gap: 16px;
	}
`

const DetailItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

const DetailLabel = styled.label`
	font-size: 13px;
	font-weight: 600;
	color: ${props => props.theme.colors.text.titleText};
`

const DetailValue = styled.p`
	font-size: 16px;
	color: ${props => props.theme.colors.text.secondaryText};
	margin: 0;
	font-weight: 400;
`

const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 360px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		position: fixed;
		left: 0;
		right: 0;
		bottom: ${MOBILE_BOTTOM_NAV_HEIGHT};
		z-index: 20;
		margin-top: 0;
		padding: 12px 16px;
		width: auto;
		background: ${props => props.theme.colors.brand.white};
	}
`

export default ConfirmSingleAppointment
